import { render, staticRenderFns } from "./NewConfirmationHandler.vue?vue&type=template&id=527aeb62&"
import script from "./NewConfirmationHandler.vue?vue&type=script&lang=js&"
export * from "./NewConfirmationHandler.vue?vue&type=script&lang=js&"
import style0 from "./NewConfirmationHandler.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports